import * as React from 'react';
import { useTranslations } from 'next-intl';
import { Box } from '@mentimeter/ragnar-ui/box';
import { Clickable } from '@mentimeter/ragnar-ui/clickable';
import { Text } from '@mentimeter/ragnar-ui/text';

export const SlideError = () => {
  const t = useTranslations('presenting.slide_error');
  const onClick = () => window.location.reload();

  return (
    <Box mt={3} width="100%" alignItems="center" justifyContent="center">
      <Clickable onClick={onClick}>
        <Text fontSize={4} color="primary" fontWeight="semiBold">
          {t('reload_button')}
        </Text>
      </Clickable>
      <Text mt={2} textAlign="center">
        {t('slide_error_message')}. {t('try_reload_message')}.{' '}
        {t('contact_support_message')}.
      </Text>
    </Box>
  );
};
